import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { CREATE_ODOO_SALES_ORDERS } from "./graphql";
import OdooSalesOrderView from "./OdooSalesOrderView";

const CreateOdooSOView = ({ source, orders, onCompleted }) => {
  const formattedOrders = orders.map((order) => {
    const lines = order.lines.map((line) => ({
      ...line,
    }));
    return { ...order, lines };
  });

  const ordersNotSynced = formattedOrders.filter(
    (order) => !order.odooSaleOrder,
  );

  const [createOrders, createOrdersRes] = useMutation(
    CREATE_ODOO_SALES_ORDERS,
    {
      variables: { source, orders },
      onCompleted() {
        Alert("success", "Orders sent to Odoo successfully");
        onCompleted();
      },
      onError(error) {
        window.alert(parseError(error));
      },
      refetchQueries: ["FETCH_ODOO_EXTERNAL_SALES_ORDERS"],
      awaitRefetchQueries: true,
    },
  );

  function createHandler() {
    const mappedOrders = orders.map((order) => {
      const mappedLines = order.lines.map((line) => ({
        productOdooId: line.odooProduct.id,
        quantity: line.quantity,
        unitPrice: line.unitPrice,
      }));
      return {
        orderId: order.sourceOrderId,
        orderNumber: order.orderNumber,
        partnerId: order.odooCustomer.id,
        partnerShippingId: order.odooDeliveryAddress.id,
        lines: mappedLines,
      };
    });

    createOrders({ variables: { source, orders: mappedOrders } });
  }

  return (
    <div className="text-sm">
      <div className="space-y-6">
        {formattedOrders.map((order, index) => (
          <OdooSalesOrderView key={index} order={order} warehouse="FSI" />
        ))}
      </div>

      <div className="mt-6">
        <Button
          disabled={ordersNotSynced.length === 0}
          primary
          onClick={createHandler}
          loading={createOrdersRes.loading}
        >
          Send to Odoo({ordersNotSynced.length} valid orders)
        </Button>
      </div>
    </div>
  );
};

export default CreateOdooSOView;
